import { E2EElement, newE2EPage } from "@stencil/core/testing";
const validator = require("html-validator");

export const testValidHtmlElement = async (
    el: E2EElement,
    ignore?: string[]
) => {
    const ignored = ["no-unknown-elements", ...(ignore || [])];
    const options = {
        validator: "WHATWG",
        data: el,
        isFragment: true,
        ignore: ignored.filter(
            (item, index) => ignored.indexOf(item) === index
        ),
    };
    const result = await validator(options);
    expect(result.errors).toEqual([]);
    expect(result.warnings).toEqual([]);
};

export const testValidHtml = async (html: string, ignore?: string[]) => {
    const page = await newE2EPage();
    await page.setContent(`<div class="test-target">${html}</div>`);
    await page.waitForChanges();
    const el = await page.find(".test-target");
    await testValidHtmlElement(el, ignore);
};
